import PrimeInvestMoreContainer from "./PrimeInvestMoreContainer";
import PrimeInvestMoreStore from "./PrimeInvestMoreStore";

export default PrimeInvestMoreStore(PrimeInvestMoreContainer);
